import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const skuDataProfileSocket = io(`${socketBaseUrl}/sku-data-profile`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default skuDataProfileSocket;
